import React from 'react';
import PropTypes from 'prop-types';
import WhatIfClientScenarioInsightContent
  from 'Views/Page/Content/Templates/FacetPlanClientScenarioInsightTemplate/InsightContent/Insight';
import { FDBox } from '@facet-wealth/design';

const InsightsTabContent = ({ resource: scenarioNoteResource }) => {
  return (
    <FDBox padding={400}>
      <WhatIfClientScenarioInsightContent
        resource={scenarioNoteResource}
        hideTitle
      />
    </FDBox>
  );
};

InsightsTabContent.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default InsightsTabContent;
